/* import __COLOCATED_TEMPLATE__ from './operating-temperature.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../../../utils/utils';

export default class OperatingTemperature extends Component {
  @service validationService;
  @service('aditools-analytics') analytics;

  @action minValueChange(value) {
    this.args.model.signalChainHandler.dac.data.operatingTemperature.min = value;
    this.handleOperatingTemperatureChange();
  }

  @action maxValueChange(value) {
    this.args.model.signalChainHandler.dac.data.operatingTemperature.max = value;
    this.handleOperatingTemperatureChange();
  }

  @action handleOperatingTemperatureChange() {
    if (this.args.updateAppData) this.args.updateAppData();

    this.analytics.setWebEvent(
      Utils.getToolName(),
      'setOperatingTemperature',
      `${this.args.model.signalChainHandler.dac.data.operatingTemperature.min} to ${this.args.model.signalChainHandler.dac.data.operatingTemperature.max}`,
    );
  }

  get errorsExist() {
    return this.validationService.appParamsTabErrors.minOperatingTemperature ||
      this.validationService.appParamsTabErrors.maxOperatingTemperature
      ? true
      : false;
  }
}
